import React, { useState } from 'react';
import { Button } from '@pushpay/button';
import Dropdown from '@pushpay/dropdown';
import { ArrowSingleIcon, LoadingOvalIcon, OrgPlaceholderIcon, TickIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { useLink } from '../link-provider';
import useStyles from './use-old-styles';

const OrgSwitcherItem = ({
  logoUrl,
  name,
  isMobile,
  icon,
  classes: classesProp,
  className: classNameProp
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classes.orgLine, classNameProp);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.orgLine, {
      [classes.orgItemMobile]: isMobile
    }, className)
  }, logoUrl ? /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    className: classes.orgLogo,
    alt: name
  }) : /*#__PURE__*/React.createElement(OrgPlaceholderIcon, {
    "data-pp-at-target": `org-switch-org-item-${name}`,
    className: classes.orgLogo
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.orgName
  }, name), /*#__PURE__*/React.createElement("div", {
    className: classes.orgItemIcon
  }, icon));
};

export const OrgSwitcher = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    'data-pp-at-target': targetId,
    organizations,
    currentOrganization,
    isMobile,
    selectOrganizationLabel,
    onItemClick
  } = props;
  const classes = useStyles(classesProp);
  const [isMobileOverlayVisible, setIsMobileOverlayVisible] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [selectedOrgKey, setSelectedOrgKey] = useState('');

  const getIcon = key => {
    if (key === currentOrganization.key) {
      return /*#__PURE__*/React.createElement(TickIcon, {
        "data-pp-at-target": `${targetId}-tick-icon`
      });
    }

    if (key === selectedOrgKey && itemLoading) {
      return /*#__PURE__*/React.createElement(LoadingOvalIcon, null);
    }

    return null;
  };

  const {
    Link
  } = useLink();
  const overlay = /*#__PURE__*/React.createElement("div", {
    className: classes.orgOverlayWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.overlayHeader
  }, isMobile && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: clsx(classes.orgItemMobile, classes.selectOrganization),
    onClick: () => setIsMobileOverlayVisible(false),
    "data-pp-at-target": `${targetId}-mobile-org-label`
  }, /*#__PURE__*/React.createElement(ArrowSingleIcon, {
    classes: {
      root: classes.orgSwitcherBackIcon
    },
    "data-pp-at-target": `${targetId}-back`,
    direction: "left"
  }), selectOrganizationLabel)), /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.options)
  }, organizations.map(({
    key,
    logoUrl,
    name,
    url,
    to
  }) => {
    const linkProps = {
      href: url,
      to
    };
    const icon = getIcon(key);
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      key: key,
      "data-pp-at-target": `${targetId}-${key}-link`,
      className: clsx(classes.orgLink, {
        [classes.currentOrgLink]: key === currentOrganization.key
      }, key !== selectedOrgKey && itemLoading && classes.notSelectedOrg)
    }, linkProps, {
      onKeyDown: event => {
        if (event.key === 'Enter') {
          event.stopPropagation();
          setSelectedOrgKey(key);

          if (onItemClick) {
            onItemClick({
              event,
              organizationKey: key,
              setItemLoading
            });
          }
        }
      },
      onClick: event => {
        setSelectedOrgKey(key);

        if (onItemClick) {
          onItemClick({
            event,
            organizationKey: key,
            setItemLoading
          });
        }
      }
    }), /*#__PURE__*/React.createElement(OrgSwitcherItem, {
      isMobile: isMobile,
      name: name,
      logoUrl: logoUrl,
      icon: icon
    }));
  })));
  const className = clsx(classes.root, classNameProp);

  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(className, classes.orgSummary),
      "data-pp-at-target": targetId
    }, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      className: clsx(classes.orgSwitcherMobileCurrent),
      onClick: () => setIsMobileOverlayVisible(true),
      "data-pp-at-target": `${targetId}-mobile-org-label`
    }, /*#__PURE__*/React.createElement(OrgSwitcherItem, {
      name: currentOrganization.name,
      logoUrl: currentOrganization.logoUrl,
      isMobile: isMobile,
      icon: /*#__PURE__*/React.createElement(ArrowSingleIcon, {
        fontSize: "16px",
        "data-pp-at-target": `${targetId}-mobile-open-org-selections`,
        direction: "right"
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.overLayMobile, {
        [classes.showOverLayMobile]: isMobileOverlayVisible
      })
    }, overlay));
  }

  return /*#__PURE__*/React.createElement(Dropdown, {
    className: className,
    classes: {
      summary: classes.orgButton,
      overlay: classes.overlay
    },
    alignment: "right",
    "data-pp-at-target": targetId,
    overlay: () => overlay
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.orgName
  }, currentOrganization.name));
};